// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';

export const DeleteContact = t.struct({
    isDeleteBusinessContactsFlowActive: t.Boolean,
    isDeleteContactWarningModalVisible: t.Boolean,
    selectedContactIdsToDelete: t.list(t.Number),
    isDeleteContactsSuccessMessageShown: t.Boolean,
    successCount: t.Number,
    errorCount: t.Number
}, {
    defaultProps: {
        isDeleteBusinessContactsFlowActive: false,
        isDeleteContactWarningModalVisible: false,
        selectedContactIdsToDelete: [],
        isDeleteContactsSuccessMessageShown: false,
        successCount: 0,
        errorCount: 0
    },
    name: 'DeleteContact',
    strict: true
});
